module.exports = {
  formTypes: [
    { value: 'patient_facing_form', label: 'Patient-facing form' },
    { value: 'clinical_template', label: 'Clinical template' }
  ]
};
